import { useEffect, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import { EnumLinkedInFlow } from 'tdc-web-backend/enums/enums';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../../../components/loading-indicator/LoadingIndicator';
import useNotification from '../../../utils/hooks/useNotification';
import useAuth from '../../../utils/hooks/useAuth';

const OAuthLinkedIn = ({ flow }: { flow: EnumLinkedInFlow }) => {
  const [isLoading, setIsLoading] = useState(true);
  const { notify } = useNotification();
  const navigate = useNavigate();
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const code = query.get('code');
  const state = query.get('state');
  const error = query.get('error');
  const { t } = useTranslation();
  const { loginLinkedIn } = useAuth();

  useEffect(() => {
    if (code && state) {
      loginLinkedIn(
        { code, state, flow },
        {
          onSuccess: (data) => {
            setIsLoading(false);
          },
          onError: (error) => {
            setIsLoading(false);
            let errorMessage = t('errors.errorDuringLinkedInAuth');

            if (
              typeof error.error !== 'string' &&
              error.error.response &&
              error.error.response.data &&
              error.error.response.data.message
            ) {
              errorMessage += `: ${error.error.response.data.message}`;
            }
            notify.error(errorMessage);
            navigate('/login', { replace: true });
          },
        },
      );
      return;
    }
    if (error) {
      setIsLoading(false);
      notify.error(t('errors.errorDuringLinkedInAuth'));
      navigate('/login');
      return;
    }
    if (!code && !state && !error) {
      setIsLoading(false);
      navigate('/login', { replace: true });
    }
  }, [code, error]);

  return (
    <Stack>
      <Typography variant="h4" fontWeight={700} sx={{ mb: 5, mt: 5 }}>
        {t('register.linkedInAuthentication')}
      </Typography>

      {isLoading && <LoadingIndicator />}
    </Stack>
  );
};
export default OAuthLinkedIn;
